var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-layout"},[_c('Layout',[_c('Header',[_c('headerCom')],1),_c('Content',[_c('Layout',{staticStyle:{"overflow-x":"auto","padding":"0px"}},[_c('router-view')],1)],1),_c('Footer',[_c('footerCom')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }